module.exports = __webpack_public_path__ + "img/correction-min.d1d4f320.png";